export default [
  {
    path: "mapa-clientes",
    name: "heat-map",
    component: () => import("@/modules/heat-map/views/HeatMap.vue"),
  },
];
